// import { debouncer, documentReady } from "../Utility/utils";
import Flickity from "flickity";
import "flickity-fade";
import "flickity/dist/flickity.min.css";


const initializeBlock = function( $block ){
  // First, Determine which block we're in, and set the args accordingly.
  let slider;
  let args;

  // For backend, ensure we're targeting the actual block.
  if(!!$block[0]){
    $block = $block[0];
  }

  // Default Slider Block
  if(!!$block.querySelector('.slider_block__slider')){
    slider = $block.querySelector('.slider_block__slider');

    const flkty = new Flickity( slider, {
      cellAlign: 'left',
      contain: true,
      wrapAround: true,
      pageDots: false,
      prevNextButtons:false,
      adaptiveHeight: true
    });

    //set up previous button
    $block.querySelector('.slider-arrow-previous').addEventListener("click", (e) => {
      flkty.previous(true);
    });

    //set up next button
    $block.querySelector('.slider-arrow-next').addEventListener("click", (e) => {
      flkty.next(true);
    });

    //set up dots
    const dotContainer = $block.querySelector(".slider-dots");

    for( let i = 0; i < flkty.cells.length; i++ ) {
      const dot = document.createElement("div")
      dot.classList.add("slider-dot");
      dot.classList.add(`slider-dot-${i}`);

      if( i === flkty.selectedIndex ) {
        dot.classList.add("selected");
      }

      dotContainer.append(dot);

      dot.addEventListener('click', () => {
        flkty.select( i, false, false );
      });
    }

    flkty.on( 'change', (index) => {
      $block.querySelectorAll(".slider-dot").forEach( sd => sd.classList.remove("selected") );
      $block.querySelector(`.slider-dot-${index}`).classList.add("selected");
    } );

    // After the page is done loading, trigger a resize to ensure the text slider offset on mobile is configured correctly.
    document.addEventListener('pageloaded', function(){
      var el = document; // This can be your element on which to trigger the event
      var event = document.createEvent('HTMLEvents');
      event.initEvent('resize', true, false);
      el.dispatchEvent(event);
    });
  }

  // Client Slider Block
  if(!!$block.querySelector('.grid_slider__slider')){
    sliders = $block.querySelectorAll('.grid_slider__slider');

    sliders.forEach(slider => {
      var flkty = new Flickity(slider, {
        prevNextButtons: false,
        fade: true,
        autoPlay: 4000
      });
    });
  }
}


// Initialize the slider on the front end
window.addEventListener('load', function(){
  var sliders = document.querySelectorAll('.slider-grid, .grid_slider');
  Array.prototype.forEach.call(sliders, function(el, i){
    initializeBlock(el);
  });
});


// Initialize dynamic block preview (editor).
if( window.acf ) {
  window.acf.addAction( 'render_block_preview/type=slider', initializeBlock );
  window.acf.addAction( 'render_block_preview/type=grid-card-slider', initializeBlock );
}
